//https://github.com/waylonflinn/xlsx-workbook/blob/master/index.js
import XLSX from 'xlsx'
import FileSaver from 'file-saver'

import {excelWs} from './excelWs'

const EventEmitter = require('events').EventEmitter

export class excel {

  constructor (args) {
    this.event = new EventEmitter()
		this.wopts = { bookType:'xlsx', bookSST:false, type:'binary' }
		//this.ws_name = "SheetJS"
		/*this.file = {
			url: "http://siong.dongnocchi.it/siong/upload/tmp/"
			,name: "prova.xslx"
		}
		*/
		this.wb = {
			Sheets: {}
			,Props: {}
			,SSF: {}
			,SheetNames: []
		}
		console.log(":............EXCEL................:")
	}

	wsNew(){
		return new excelWs()
	}

	wsClean(){
      this.wb.Sheets = {}
      this.wb.SheetNames = []
		return this
	}

	wscreate(ws,ws_name){
		console.log(ws.range)
		ws.ws['!ref'] = XLSX.utils.encode_range(ws.range);
		console.log(typeof this.wb.Sheets[ws_name])
      /* add worksheet to workbook */
      console.log("ws_name: " + typeof this.wb.Sheets[ws_name] )
		if(typeof this.wb.Sheets[ws_name] != 'object')
         this.wb.SheetNames.push(ws_name)
         console.log("ws_name POST: " + typeof this.wb.Sheets[ws_name] )
		this.wb.Sheets[ws_name] = ws.ws
		return this
	}

	save(){
		var wbout = XLSX.write(this.wb,this.wopts);
		function s2ab(s) {
			var buf = new ArrayBuffer(s.length);
			var view = new Uint8Array(buf);
			for (var i=0; i!=s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
			return buf;
		}
		/* the saveAs call downloads a file on the local machine */
		FileSaver.saveAs(new Blob([s2ab(wbout)],{type:"application/octet-stream"}), "test.xlsx");
	}




/*





















	data(labels,data){
		var cols = []
      	var initialCol = 0
      	var row = 0
		var col = 0

		if(arguments.length>2)
			row = arguments[2]
		if(arguments.length>3)
			initialCol = arguments[3]

		col = initialCol	
      	for (let label of labels){
        //if(label!='prgId' && label!='prgId.Nome'&& label!='prgOutin'         && label!='cliId'         && label!='cliId.Nome'         && label!='1.Nome'){
          //cols.push(label)
          this.cell(row,col,label)
          col++
        //}
      	}
	  
		for (let rows of data){
			row++
			col=initialCol
			for (let colname of labels){
				this.cell(row,col,rows[colname])
				col++
			}
			
		}
		return this

	}
	cell(row,col,value,format){
		var cell = { v: value}
		//console.log(":............RANGE................:")
		//console.log(this.range)
		if(this.range.e.c < col) this.range.e.c = col
		if(this.range.e.r < row) this.range.e.r = row

		// create the correct cell reference 
		var cell_ref = XLSX.utils.encode_cell({c:col,r:row});
		// determine the cell type 
		if(typeof cell.v === 'number') cell.t = 'n';
		else if(typeof cell.v === 'boolean') cell.t = 'b';
		else cell.t = 's';

		// add to structure 
		this.ws[cell_ref] = cell;
		//console.log(this.ws)
		return this
	}
	

	worksheet(ws_name,data){
		var initialRow = 0
		if(arguments.length>2)
			initialRow = arguments[2]

		var ws = {}
		var label = data[0]

		// the range object is used to keep track of the range of the sheet 
		var range = {s: {c:0, r:0}, e: {c:0, r:0 }}

		// Iterate through each element in the structure 
		for(var R = initialRow; R != data.length; ++R) {
			if(range.e.r < R) range.e.r = R;
			for(var C = 0; C != data[R].length; ++C) {
				if(range.e.c < C) range.e.c = C;
					// create cell object: .v is the actual data 
					var cell = { v: data[R][C]}
					if(cell.v == null) continue
				
				// GESTISCE I DOCUMENTI 
				//if(label[C]=='docfile' && R>0){
				//	if(data[R][C]!=''){
				//		var file = JSON.parse(data[R][C])[0]
				//		var linkfile ="http://siong.dongnocchi.it/siong/upload/tmp/"+file.url
				//		cell.l = {Target:linkfile,Tooltip:file.name}
				//		cell.v = file.name
				//	} 
				//}
				
				if(label[C]=='atvDescrizione' && R>0){
					if(data[R][C]!=''){
						cell.h = true
						cell.s = {bold: true}
					}
				}
					
				// create the correct cell reference 
				var cell_ref = XLSX.utils.encode_cell({c:C,r:R});

				/* determine the cell type 
				if(typeof cell.v === 'number') cell.t = 'n';
				else if(typeof cell.v === 'boolean') cell.t = 'b';
				else cell.t = 's';

				/* add to structure 
				ws[cell_ref] = cell;
			}
			
		}
    
		ws['!ref'] = XLSX.utils.encode_range(range);

		/* add worksheet to workbook 
		this.wb.SheetNames.push(ws_name);
		this.wb.Sheets[ws_name] = ws;

		return this
	}
	*/
	

}
export default new excel